import React from "react";
import { motion } from "framer-motion";
import { BookOpen, MessageCircle, Heart } from "lucide-react";

export default function SanctuaryGlimpse() {
    const screens = [
        {
            title: "The Soul Diary",
            desc: "A private garden for your thoughts. Voice your truth or write in silence.",
            icon: BookOpen,
            gradient: "from-indigo-500/20 to-blue-500/20",
            delay: 0
        },
        {
            title: "Divine Connect",
            desc: "1-on-1 human witnessing. No bots, just presence and deep listening.",
            icon: MessageCircle,
            gradient: "from-brand-orange/20 to-rose-500/20",
            delay: 0.1
        },
        {
            title: "Wisdom Scrolls",
            desc: "Centuries of insights condensed for the modern seeker.",
            icon: Heart,
            gradient: "from-teal-500/20 to-emerald-500/20",
            delay: 0.2
        }
    ];

    return (
        <div className="grid md:grid-cols-3 gap-8 w-full max-w-6xl mx-auto px-6 py-20">
            {screens.map((screen, idx) => (
                <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: screen.delay, duration: 0.8 }}
                    className="group relative"
                >
                    {/* The "Ghost" Interface Preview */}
                    <div className={`relative h-64 md:h-80 rounded-[2.5rem] p-8 overflow-hidden bg-white/5 dark:bg-white/[0.02] border border-white/10 backdrop-blur-xl mb-6 shadow-2xl transition-all duration-500 hover:scale-[1.02] hover:border-white/20`}>
                        <div className={`absolute inset-0 bg-gradient-to-br ${screen.gradient} opacity-50 blur-3xl group-hover:opacity-70 transition-opacity`} />
                        
                        {/* Abstract UI Elements */}
                        <div className="relative z-10 flex flex-col h-full items-center justify-center space-y-6">
                            <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center backdrop-blur-md border border-white/10">
                                <screen.icon className="w-8 h-8 text-white/40" />
                            </div>
                            <div className="space-y-2 w-full">
                                <div className="h-1.5 w-3/4 mx-auto bg-white/10 rounded-full" />
                                <div className="h-1.5 w-1/2 mx-auto bg-white/5 rounded-full" />
                                <div className="h-1.5 w-2/3 mx-auto bg-white/10 rounded-full" />
                            </div>
                        </div>
                    </div>

                    <div className="text-center px-4">
                        <h3 className="text-xl md:text-2xl font-display text-gray-900 dark:text-white mb-2">{screen.title}</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed italic font-serif px-2">
                            "{screen.desc}"
                        </p>
                    </div>
                </motion.div>
            ))}
        </div>
    );
}
